<template>
  <div
  fluid
  class="grey lighten-5 main-container"
  >
    <v-navigation-drawer
    permanent
    :color="config.background"
    width="34%"
    absolute
    class="scroll-drawer"
    >
      <v-overlay 
      v-if="currentlyLoading"
      opacity="0.2"
      >
        <v-progress-circular 
        indeterminate
        size="128"
        absolute
        :color="config.primary"
        >
        </v-progress-circular>
      </v-overlay>
      <v-col
      class=""
      no-gutters
      >
        <v-row>
          <v-card
            :dark="config.dark_background"
            :color="config.primary"
            class="mb-3"
            style="width: 100%"
            tile
            elevation="4"
          >
            <v-card-title class="display-1 text-break">
              <v-icon large left>mdi-account</v-icon> Your chips ( {{chips}} / {{maxChips}} )
            </v-card-title>
          </v-card>
        </v-row>
        <v-row
        v-bind:key="index"
        v-for="(chip, index) in itemList"
        class="mb-1"
        >
          <v-card
            :dark="config.dark_background"
            :color="config.background_dark_slight"
            style="width: 100%"
            outlined
            tile
            @click="clickItem(chip)"
          >
            <v-list-item three-line>
              <v-list-item-avatar
                tile
                size="80"
              >
                <v-img
                  lazy-src=""
                  :src="chip.image"
                  width="80"
                  height="80"
                  style="border-radius: 50%;"
                >
                </v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <div class="overline font-weight-bold">
                  <v-tooltip open-delay="100" v-if="chip.private" right :color="config.special_1">
                    <template v-slot:activator="{ on }"> <!-- Activate toolbar if you hover over it -->
                      <v-icon class="ml-3 mb-3" :color="config.special_1" v-on="on" >mdi-lock-check</v-icon>
                    </template>
                    <h3> Only you can view and edit this chip</h3>
                  </v-tooltip>
                </div>
                <v-list-item-title class="headline mb-1">
                  {{chip.name}}
                </v-list-item-title>
                <v-list-item-subtitle>Created {{ getFormattedDate(chip.date_created)}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-row>
      </v-col>
    </v-navigation-drawer>
    <v-card
    :color="config.background"
    :dark="config.dark_background"
    class="float-right scroll"
    style="width: 66%; height: 100%"
    tile
    elevation="0"
    >
      <v-list-item two-line v-if="!itemInfo">
        <v-list-item-content>
          <div class="headline mb-1" v-if="this.itemList.length > 0">
            Click on an item to the left to view details.
          </div>
          <div class="headline mb-1" v-if="this.itemList.length < 1">
            It looks like you don't have any chips! Click <a @click="navigateTo('create')">here</a> to create a chip!
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-container v-if="itemInfo" elev="0" style="height: 90%; width: 95%; margin-top: 20px;">
        <v-row >
          {{ itemInfo.name }}
          <v-tooltip open-delay="100" left v-bind:color="config.cancel">
            <template v-slot:activator="{ on }"> <!-- Activate toolbar if you hover over it -->
              <v-btn
                v-bind:color="config.cancel"
                class="ml-auto"
                large
                dark
                icon
                v-on="on"
                @click="deleteItem(itemInfo)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <h3>Delete this chip forever?</h3>
          </v-tooltip>
        </v-row>
        <v-row>
          <v-list-item-subtitle>
            <span>Created {{getFormattedDate(itemInfo.date_created)}}</span>
          </v-list-item-subtitle>
        </v-row>
        <v-row class="my-4">
          <v-btn
            elevation="3"
            :dark="config.dark_primary"
            v-bind:color="config.primary"
            large
            @click="editChip(itemInfo)"
          >
            <span>Edit this chip</span>
            <v-icon right>mdi-circle-edit-outline</v-icon>
          </v-btn>
        </v-row>

        <v-row class="my-4">
          <v-btn
            elevation="3"
            :dark="config.dark_primary"
            v-bind:color="config.primary"
            large
            @click="printChip(itemInfo)"
          >
            <span>Print</span>
            <v-icon right>mdi-printer</v-icon>
          </v-btn>
        </v-row>
        <div style="width: 300px; margin-left: auto; margin-right: auto;">
          <div class="overlay-box">
            <img :src="overlays[activeOverlay]" class="overlay-chip"/>
            <img :src="itemInfo.image" class="overlay-image"/>
          </div>
          <v-row justify="center" class="text-center">
            <v-col cols="12" sm="3">
              <v-btn @click="switchChip('sub')" icon>
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn :color="config.secondary" @click="switchChip('reset')" elevation="0">
                Preview {{activeOverlay + 1}} / {{overlays.length}}
              </v-btn>
            </v-col>
            <v-col cols="12" sm="3">
              <v-btn @click="switchChip('add')" icon>
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-card>
    <v-dialog
      v-model="loginModal"
      width="500"
    > <!-- Login Prompt -->
      <modal>
      </modal>
    </v-dialog>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition"  :key="0"> <!-- Print Page -->
      <f-s-modal :canvas_data="printInfo.image">
        <template v-slot:actions>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Print and Adjust</v-toolbar-title>
        </template>
      </f-s-modal>
    </v-dialog>
  </div>
</template>

<script>
import FSModal from '@/components/FSModal.vue'
import ItemService from '@/services/ItemService'
import { mapGetters } from 'vuex'
import Modal from '@/components/Modal.vue'
import config from '@/config/config'

export default {
  data () {
    return {
      maxChips: null,
      chips: null,
      itemList: [],
      itemInfo: null,
      errors: null,
      loginModal: false,
      config,
      currentlyLoading: true,
      dialog: false,
      printInfo: {},
      activeOverlay: 0,
      overlays: [
        require('@/assets/blackchip.svg'),
        require('@/assets/redchip.svg'),
        require('@/assets/greenchip.svg'),
        require('@/assets/bluechip.svg'),
        require('@/assets/whitechip.svg'),
      ],
    }
  },
  methods: {
    async switchChip(action) {
      switch (action) {
        case 'sub':
          if (this.activeOverlay > 0) this.activeOverlay = this.activeOverlay - 1;
          break
        case 'add':
          if (this.activeOverlay < this.overlays.length - 1) this.activeOverlay = this.activeOverlay + 1;
          break
        case 'reset':
          if (this.activeOverlay != 0) this.activeOverlay = 0
          break
      }
    },
    addImages (array) {
      return array.map(function (item) {
        item.image = config.backendURL + '/public/icons/' + item._id + '.png'
        return item
      })
    },
    getFormattedDate(date_string) {
      const date = new Date(date_string)
      const dtf = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' }) 
      const [{ value: mo },,{ value: da },,{ value: ye }] = dtf.formatToParts(date) 
      return `${mo}  ${da} - ${ye}`
    },
    editChip (item) {
      this.$router.push({
          name: 'create',
          params: {
              itemInfo: item
          }
      })
    },
    isOwner(item) {
      if (this.getUser._id == item.user_created) {
        return true
      } else {
        return false
      }
    },
    navigateTo (route) {
      this.$router.push({name:route})
    },
    async deleteItem(item) {
      try {
        this.itemInfo = null
        this.currentlyLoading = true
        const sendObj = {
          itemId: item._id,
          token: this.getUser.token
        }
        const response = await ItemService.delete(sendObj)
        this.info = false
        this.itemList = this.itemList.filter((filterItem) => filterItem._id != response.data._id)
        this.chips --
        this.currentlyLoading = false
      } catch(error) {
        this.currentlyLoading = false
        this.$router.push({name: 'home'})
        this.$store.dispatch('setAlert', error)
      }
    },
    async clickItem (item) {
      try {
        this.itemInfo = item
      } catch (error) {
        this.$store.dispatch('setAlert', error)
      }
    },
    async getUserChips () {
      try {
        if (this.loggedIn) {
          this.currentlyLoading = true
          const response = await ItemService.getUserCreated({token: this.getUser.token})
          const array = await this.addImages(response.data.items)
          this.currentlyLoading = false
          this.itemList = array
        } else {
          this.loginModal = true
        }
      } catch (error) {
        this.currentlyLoading = false
        this.$store.dispatch('setAlert', error)
      }
    },
    async printChip (item) {
      this.itemInfo = item
      this.printInfo = item
      this.currentlyLoading = true
      this.dialog = true
      this.currentlyLoading = false
    }
  },
  components: {
    Modal,
    FSModal
  },
  computed: {
    ...mapGetters({
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser'
    })
  },
  mounted () {
    this.getUserChips()
    ItemService.getChipCount({token: this.getUser.token}).then(response => {
      this.maxChips = response.data.max
      this.chips = response.data.chips
    }).catch(error => {
      this.$store.dispatch('setAlert', error)
    })
  }
}
</script>

<style scoped>
  .main-container {
    height: 100%;
  }
  .scroll {
    overflow-y: auto;
  }
  .right-item {
    width: 60px;
  }
  .invis {
    display: none;
  }
  .scroll-drawer {
    scrollbar-color: rgb(0, 0, 0);
  }
  .overlay-chip {
    position: absolute;
    width: 100%;
    z-index: 2;
  }

  .overlay-image {
    border-radius: 50%;
    top: 50%;
    left: 50%;
    position: absolute;
    transform:translate(-50%,-50%);
    width: 70%;
    z-index: 1;
  }

  .overlay-box {
    position: relative;
    width: 300px;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
  }
</style>